import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, mergeProps as _mergeProps, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-80135556"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "input-group-text mb-3 text-center" }
const _hoisted_4 = {
  class: "input-group mb-3",
  style: {"width":"280px"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("span", { id: "inputGroup-sizing-default-1" }, "Rename")
], -1))
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  class: "input-group mb-3",
  style: {"width":"280px"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("span", { id: "inputGroup-sizing-default-2" }, "Child name")
], -1))
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "mb-3 row justify-content-md-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1))
const _hoisted_15 = { class: "col input-group mb-3" }
const _hoisted_16 = {
  class: "input-group-text",
  for: "inputGroupSelect01"
}
const _hoisted_17 = { value: "0" }
const _hoisted_18 = { value: "1" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = { class: "modal-dialog" }
const _hoisted_22 = { class: "modal-content" }
const _hoisted_23 = { class: "modal-header" }
const _hoisted_24 = {
  class: "modal-title",
  id: "modal-title"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_26 = { class: "modal-body" }
const _hoisted_27 = { class: "modal-footer" }
const _hoisted_28 = {
  class: "btn btn-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_29 = { class: "modal-dialog" }
const _hoisted_30 = { class: "modal-content" }
const _hoisted_31 = { class: "modal-header" }
const _hoisted_32 = {
  class: "modal-title",
  if: "modal-title"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_34 = { class: "modal-body" }
const _hoisted_35 = { class: "modal-footer" }
const _hoisted_36 = {
  class: "btn btn-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_37 = { class: "modal-dialog" }
const _hoisted_38 = { class: "modal-content" }
const _hoisted_39 = { class: "modal-header" }
const _hoisted_40 = {
  class: "modal-title",
  if: "modal-title"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_blocks_tree = _resolveComponent("blocks-tree")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Loading, {
      active: _ctx.renderComponent,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.renderComponent) = $event)),
      "can-cancel": false,
      "is-full-page": false
    }, null, 8, ["active"]),
    (!_ctx.renderComponent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_blocks_tree, {
            onNodeClick: _ctx.show,
            data: _ctx.permissionsTreeData,
            horizontal: _ctx.treeOrientation==='1',
            collapsable: false,
            props: {
        label: 'label', expand: 'expand', children: 'children',  key:'some_id', permission: 'permission'}
          }, {
            node: _withCtx(({data}) => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(data.label), 1)
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "aria-label": "Default",
                  "aria-describedby": "inputGroup-sizing-default",
                  "onUpdate:modelValue": ($event: any) => ((data.rename) = $event),
                  style: {"width":"100px"}
                }, null, 8, _hoisted_6), [
                  [_vModelText, data.rename]
                ]),
                _createElementVNode("button", {
                  class: "btn btn-outline-secondary",
                  onClick: ($event: any) => (_ctx.renameButton(data)),
                  type: "button",
                  id: "inputGroup-sizing-default"
                }, "Rename", 8, _hoisted_7)
              ], 512), [
                [_vShow, data.expand]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "aria-label": "Default",
                  "aria-describedby": "inputGroup-sizing-default",
                  "onUpdate:modelValue": ($event: any) => ((data.newChildName) = $event),
                  style: {"width":"100px"}
                }, null, 8, _hoisted_10), [
                  [_vModelText, data.newChildName]
                ]),
                _createElementVNode("button", {
                  class: "btn btn-outline-secondary",
                  type: "button",
                  id: "inputGroup-sizing-default-3",
                  onClick: ($event: any) => (_ctx.addChildButton(data))
                }, "Create", 8, _hoisted_11)
              ], 512), [
                [_vShow, data.expand]
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _withDirectives(_createElementVNode("button", {
                  style: {"width":"100px"},
                  type: "button",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#delete-modal",
                  class: "btn btn-danger m-1",
                  onClick: ($event: any) => (_ctx.deleteCheck(data))
                }, "Delete", 8, _hoisted_12), [
                  [_vShow, _ctx.showDelete(data)]
                ])
              ], 512), [
                [_vShow, data.expand]
              ])
            ]),
            _: 1
          }, 8, ["onNodeClick", "data", "horizontal"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t.changeOrientation), 1),
        _withDirectives(_createElementVNode("select", {
          class: "form-select",
          id: "inputGroupSelect01",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.treeOrientation) = $event))
        }, [
          _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.$t.vertical), 1),
          _createElementVNode("option", _hoisted_18, _toDisplayString(_ctx.$t.horizontal), 1)
        ], 512), [
          [_vModelSelect, _ctx.treeOrientation]
        ])
      ]),
      _hoisted_19
    ]),
    _hoisted_20,
    _createElementVNode("div", _mergeProps({ class: "modal fade" }, _ctx.deleteCheckData, {
      id: "delete-modal",
      ref: "delete-modal",
      tabindex: "-1",
      "aria-labelledby": "modal-title",
      "aria-hidden": "true"
    }), [
      _withDirectives(_createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("h5", _hoisted_24, _toDisplayString(_ctx.$t.delete) + " " + _toDisplayString(_ctx.deleteCheckData.permission.name), 1),
            _hoisted_25
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t.deleteCheckDataPrev) + " \"" + _toDisplayString(_ctx.deleteCheckData.permission.name) + "\" " + _toDisplayString(_ctx.$t.deleteCheckDataAfter), 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("button", {
              class: "btn btn-danger mr-auto",
              "data-bs-dismiss": "modal",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteData()))
            }, _toDisplayString(_ctx.$t.yes), 1),
            _createElementVNode("button", _hoisted_28, _toDisplayString(_ctx.$t.no), 1)
          ])
        ])
      ], 512), [
        [_vShow, _ctx.exists ===false]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("h5", _hoisted_32, _toDisplayString(_ctx.$t.cannotDelete) + " " + _toDisplayString(_ctx.deleteCheckData.permission.name), 1),
            _hoisted_33
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t.deleteCheckDataPrev2) + " \"" + _toDisplayString(_ctx.deleteCheckData.permission.name) + "\" " + _toDisplayString(_ctx.$t.deleteCheckDataAfter2), 1)
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("button", _hoisted_36, _toDisplayString(_ctx.$t.ok), 1)
          ])
        ])
      ], 512), [
        [_vShow, _ctx.exists ===true]
      ])
    ], 16),
    _createElementVNode("div", _mergeProps({ class: "modal fade" }, _ctx.deleteCheckData, {
      id: "delete-modal",
      ref: "delete-modal",
      tabindex: "-1",
      "aria-labelledby": "modal-title",
      "aria-hidden": "true"
    }), [
      _withDirectives(_createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("h5", _hoisted_40, _toDisplayString(_ctx.$t.cannotDelete) + " " + _toDisplayString(_ctx.deleteCheckData.permission.name), 1),
            _hoisted_41
          ])
        ])
      ], 512), [
        [_vShow, _ctx.exists ===true]
      ])
    ], 16)
  ], 64))
}